import clsx from 'clsx';
import { createElement } from 'react';

export interface HeadingProps {
  centered?: boolean;
  children?: React.ReactNode;
  className?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 'xs3' | 'xs2' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  thin?: boolean;
}

export function Heading({ centered, children, className, level = 1, size, thin }: HeadingProps) {
  const headingLevel = level ?? 1;

  let headingSize = size;
  if (!headingSize) {
    if (headingLevel === 1) {
      headingSize = 'lg';
    } else if (headingLevel === 2) {
      headingSize = 'md';
    } else if (headingLevel === 3) {
      headingSize = 'sm';
    } else if (headingLevel === 4 || headingLevel === 5) {
      headingSize = 'xs';
    } else if (headingLevel === 6) {
      headingSize = 'xs2';
    }
  }

  return createElement(
    `h${headingLevel}`,
    {
      className: clsx(
        centered && 'text-center',
        headingSize === 'xs3' && clsx('text-sm', thin ? 'font-medium' : 'font-semibold'),
        headingSize === 'xs2' && clsx('text-base', thin ? 'font-medium' : 'font-semibold'),
        headingSize === 'xs' && clsx('text-lg', thin ? 'font-medium' : 'font-semibold'),
        headingSize === 'sm' && clsx('text-xl', thin ? 'font-semibold' : 'font-bold'),
        headingSize === 'md' && clsx('text-xl sm:text-2xl', thin ? 'font-semibold' : 'font-bold'),
        headingSize === 'lg' && clsx('text-2xl sm:text-3xl', thin ? 'font-semibold' : 'font-bold'),
        headingSize === 'xl' && clsx('text-3xl sm:text-4xl', thin ? 'font-bold' : 'font-extrabold'),
        'wrap-break-word',
        className
      )
    },
    children
  );
}
